import type {RouteRecordRaw} from 'vue-router';

import {adminPageRoutes} from '@/app/admin/router/pages';

export const adminRoutes: Array<RouteRecordRaw> = [
  {
    path: 'admin/',
    name: 'LKBasePage',
    redirect: '/admin/layers',
    children: [...adminPageRoutes],
  },
];
